module.exports = __webpack_public_path__ + "static/img/honor_4.a4fa71e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/honor_4.jpg
// module id = 5T4l
// module chunks = 0